import { FirmwareItem } from '@/firmware/interface'
import { getFirmwares } from '@/firmware/service'
import { Guid } from '@/utils/guid'
import { Checkbox, Form, Radio, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { BoxFirmwareItem, BoxFirmwareProps } from '../interface'

export const BoxFirmware: React.FC<BoxFirmwareProps> = (
  props: BoxFirmwareProps
) => {
  const [formwares, setFrimwares] = useState<FirmwareItem[]>([])
  const [selectIds, setSelectedIds] = useState<string[]>([])
  const [options, setOptions] = useState<any[]>([])
  const [form] = Form.useForm()
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 3 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 }
    }
  }

  const loadFirmware = async () => {
    if (props.boxes && props.boxes.length > 0) {
      let items = await getFirmwares(props.boxes[0].boxType!)
      items = items.map((x) => {
        x.id = Guid.raw()
        return x
      })
      setFrimwares(items)
    }
  }

  useEffect(() => {
    loadFirmware()
  }, [])

  useEffect(() => {
    if (props.formResult) {
      form
        .validateFields()
        .then((values: any) => {
          if (props.onFormValidate) {
            props.onFormValidate(true)
          }
          if (props.onFormSubmit) {
            const firmware = formwares.find((x) => x.id == values.firmware)
            const item: BoxFirmwareItem = {
              boxIds: selectIds,
              firmware
            }
            props.onFormSubmit(item)
            form.resetFields()
          }
        })
        .catch((info) => {
          console.log('Validate Failed:', info)
          if (props.onFormValidate) {
            props.onFormValidate(false)
          }
        })
    }
  }, [props.formResult])

  useEffect(() => {
    const ids = props.boxes?.map((x) => x.id || '') || []
    setSelectedIds(ids)
    const ops =
      props.boxes?.map((x) => {
        return { label: x.boxNo || '', value: x.id || '' }
      }) || []
    setOptions(ops)
  }, [props.boxes])

  return (
    <div>
      <Form form={form} {...formItemLayout}>
        <Form.Item label='选中FBox'>
          <Checkbox.Group
            style={{
              width: '100%',
              minHeight: 100,
              padding: 5,
              border: '1px solid #DDD'
            }}
            value={selectIds}
            options={options}
          ></Checkbox.Group>
        </Form.Item>

        <Form.Item
          label='固件版本'
          name='firmware'
          rules={[
            {
              required: true,
              message: '固件版本不能为空'
            }
          ]}
        >
          <Select style={{ width: 200 }} placeholder='请选择固件版本号'>
            {formwares.map((x) => (
              <Select.Option key={x.id} value={x.id!}>
                {x.verDetail}({x.mainVer})
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label='更新方式'>
          <Radio.Group defaultValue={1}>
            <Radio value={1}>立即更新</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </div>
  )
}
